export default [
  '$compile',
  function floatLabelText($compile) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: true,
      link: (scope, el, attrs, ngModel) => {
        scope.$watch(function() {
          return ngModel.$modelValue;
        }, function(newValue) {
          if (newValue) {
            scope.hasTextValue = true;
          } else {
            scope.hasTextValue = false;
          }
        });

        let templateAttributes = [],
          hasIcon = false;
        for (let attr in attrs) {
          if (attrs.hasOwnProperty(attr) && attr.substr(0, 1) !== '$' && attr !== 'floatLabelText' && attr !== 'placeholder') {
            templateAttributes.push(attrs.$attr[attr] + '="' + attrs[attr] + '"');
            if(attr === 'icon') hasIcon = true;
          }
        }

        let template = `
          <div class="vs-input${hasIcon ? ' input-icon' : ''}">
            ${hasIcon ? '<i class="glyphicon ' + attrs.icon + '"></i>' : ''}
            <input id="textbox_${scope.$id}" class="form-control" ng-class="{filled: hasTextValue}" ${templateAttributes.join(' ')}/>
            <label for="textbox_${scope.$id}" class="placeholder">${attrs.placeholder}</label>
            <div class="vs-input-bg"></div>
          </div>
        `;
        let linkFn = $compile(template);
        let content = linkFn(scope);
        el.replaceWith(content);
      }
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/float-labels/float-label-text.dir.js